import { FugFile } from '@campfire/file-upload-gallery';
import { useEndpointFetch } from '../../../global/network/useEndpointFetch';

export interface SaveCategoryResource {
  supportResourceId: string;
  featured: boolean;
  title: string;
  textContent: string | null;
}
export interface SaveCategoryValues {
  supportCategoryId?: string;
  title: string;
  icon?: string | null;
  colour?: string | null;
  sortOrder?: number;
  supportResources?: {
    supportResourceId: string;
    featured: boolean;
    sortOrder?: number;
  }[];
}

export const useSaveCategoryFetch = () => {
  return useEndpointFetch<
    SaveCategoryValues,
    {
      supportCategoryId: string;
    }
  >('/vm/support/category/save');
};

export const useDeleteCategoryFetch = () => {
  return useEndpointFetch<{ supportCategoryId: string }, {}>('/vm/support/category/delete');
};

export interface SaveSupportResourceValues {
  supportResourceId?: string;
  featured: boolean;
  title: string;
  textContent?: string;
  supportCategoryId: string;
  addedAttachments: FugFile[];
  attachmentCreationTokens: string[];
  removedAttachmentIds: string[];
  programIds: string[];
  activityIds: string[];
  roleIds: string[];
  tagIds: string[];
  permissionLevel?: string
}

export const useSaveSupportResourceFetch = () => {
  return useEndpointFetch<SaveSupportResourceValues, {}>('/vm/support/resource/save', { formData: true });
};

export const useDeleteSupportResourceFetch = () => {
  return useEndpointFetch<{ supportResourceId: string }, {}>('/vm/support/resource/delete');
};

export interface ReorderCategoryItem {
  supportCategoryId: string;
  sortOrder: number;
}

export const useReorderCategoriesFetch = () => {
  return useEndpointFetch<{ categories: ReorderCategoryItem[] }, {}>('/vm/support/category/reorder');
};

export interface ReorderResourceItem {
  supportResourceId: string;
  sortOrder: number;
}

export const useReorderResourcesFetch = () => {
  return useEndpointFetch<{ resources: ReorderResourceItem[] }, {}>('/vm/support/resource/reorder');
};
